import { FileFilterEditItem, IFileFilterEditItem } from "./fileFilterEditItem";

export interface IFileFilterEdit {
    item: IFileFilterEditItem;
}

export class FileFilterEdit implements IFileFilterEdit {
    item: FileFilterEditItem;

    constructor();
    constructor(obj: IFileFilterEdit);
    constructor(obj?: any) {
        this.item = new FileFilterEditItem(obj ? obj.item : null);
    }
}